import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'service-bus',
		// Ops tooling — admin only. Cascades to all queue/topic/subscription views.
		meta: {
			requireAuth: true,
			breadcrumb: 'Service Bus',
			minRole: ROLE_ADMIN,
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.SERVICE_BUS.OVERVIEW,
				component: () => {
					return import('@/views/depot/service-bus/Overview.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Service Bus',
					breadcrumb: '',
				},
			},
			{
				path: 'queues/:queueName',
				name: ROUTE_NAMES.DEPOT.SERVICE_BUS.QUEUE_MESSAGES,
				component: () => {
					return import('@/views/depot/service-bus/Queue-Messages.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Queue Messages',
					breadcrumb: 'Queue',
				},
			},
			{
				path: 'topics/:topicName',
				name: ROUTE_NAMES.DEPOT.SERVICE_BUS.TOPIC_SUBSCRIPTIONS,
				component: () => {
					return import('@/views/depot/service-bus/Topic-Subscriptions.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Topic Subscriptions',
					breadcrumb: 'Topic',
				},
			},
			{
				path: 'topics/:topicName/subscriptions/:subscriptionName',
				name: ROUTE_NAMES.DEPOT.SERVICE_BUS.SUBSCRIPTION_MESSAGES,
				component: () => {
					return import('@/views/depot/service-bus/Subscription-Messages.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Subscription Messages',
					breadcrumb: 'Subscription',
				},
			},
		],
	},
];
